import useQueryFetch from "../../../../../hooks/useQueryFetch";
import Loading from "../../../../../utils/Loader/Loading";
import request from "../../../../../utils/request";

const VaccineTableForMedicalForm = ({ user, from }) => {
  const { data: vaccineTests, isLoading } = useQueryFetch(
    ["vaccineTests", user?.id],
    () => request.getOne("reports/vaccine/reports", user?.id),
    {
      placeholderData: [],
    }
  );

  if (vaccineTests.length === 0) {
    return null;
  }

  return (
    <>
      <tr>
        <td
          colSpan={2}
          className="text-nowrap text-uppercase fw-bold text-center border border-dark"
        >
          Vaccine
        </td>
      </tr>
      <tr>
        <td colSpan={2} className="p-0 m-0 border-end-0">
          <InvestigationTable2 investigations={vaccineTests} from={from} />
        </td>
      </tr>
    </>
  );
};

export default VaccineTableForMedicalForm;
function InvestigationTable2({ investigations, from }) {
  // if investigations has only one item
  if (investigations.length === 1) {
    return (
      <table className="w-100 m-0 border-dark">
        <tbody>
          <tr>
            <td className="border-end border-dark w-25 ps-1">
              {investigations[0]?.name.toUpperCase()}
            </td>
            <td className="border-end border-dark w-25 ps-1">
              {from === "medicalForm" ? "" : investigations[0]?.result}
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
  // Pair items two-by-two
  const pairs = [];
  for (let i = 0; i < investigations?.length; i += 2) {
    pairs.push([investigations[i], investigations[i + 1]]);
  }

  return (
    <table className="w-100 m-0 border-dark">
      <tbody>
        {pairs.map(([left, right], i) => (
          <tr key={i}>
            {left && (
              <>
                <td
                  className={`border-end  ${
                    i % 2 === 0 ? "border-bottom" : ""
                  } border-dark w-25 ps-1`}
                >
                  {left?.name.toUpperCase()}
                </td>
                <td
                  className={`border-end  ${
                    i % 2 === 0 ? "border-bottom" : ""
                  } border-dark ps-1`}
                >
                  {from === "medicalForm" ? "" : right?.result}
                </td>
              </>
            )}
            {right ? (
              <>
                <td
                  className={`border-end  ${
                    i % 2 === 0 ? "border-bottom" : ""
                  } border-dark w-25 ps-1`}
                >
                  {right?.name.toUpperCase()}
                </td>
                <td
                  className={`border-end  ${
                    i % 2 === 0 ? "border-bottom" : ""
                  } border-dark ps-1`}
                >
                  {from === "medicalForm" ? "" : right?.result}
                </td>
              </>
            ) : (
              <>
                <td className="w-25 ps-1"></td>
                <td className="ps-1"></td>
              </>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
